
export default {
  name: "PubBreadcrumb",
  props: {
    breadcrumbList: {
      type: Array,
      default: []
    }
  },
  methods: {
    /**
     * 路由的跳转
     * */
    goPath(reqPath) {
      if (reqPath === -1) {
        this.$router.go(-1);
        return;
      }
      if (reqPath) {
        this.$router.replace(reqPath);
      }
    }
  }
}
